module.exports = __webpack_public_path__ + "img/ps-28.bbbbd783.jpg";